import * as GQL from "src/types/graphql";
import * as RD from "src/types/remoteData";
import { BreadcrumbType, getBreadcrumbsForHome } from ".";
import * as Url from "../url";

export const getBreadcrumbsForAvelaLabs = (
  organization: RD.RemoteData<unknown, GQL.Organization>
): BreadcrumbType[] => {
  return [
    ...getBreadcrumbsForHome(organization),
    {
      label: "What is Avela Labs?",
      href: organization
        .map((org) => Url.OrgAdmin.AvelaLabs.aboutAvelaLabs(org))
        .withDefault("#"),
    },
  ];
};
